import React, { Component } from "react";
import "font-awesome/css/font-awesome.min.css";
import setIcon from "../images/settings.svg";
import integraProcessMain from "../images/intergrationProcess-img.png";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./AboutCLiQ.css";
import pdf1 from "../pdf/Integration_Process_PDF.pdf";
class IntegrationProcess extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="left-bar rounded h-100">
                <ul>
                  <li>
                    <Link to="/experiencezone/intergration-process"
                      className="active"
                    >
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Integration Process</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experiencezone/what-we-offer">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>What we Offer</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-9">
              <div className="inner-content">
                <h1>Integration Process</h1>
                <p>
                  This section provides you information on integration
                  processes, documentations and steps to integrate with TATA
                  CLiQ
                </p>
                <div className="img-block">
                  <img src={integraProcessMain} alt="" className="img-fluid" />
                </div>
                <ul>
                  <li>
                    The Seller Portal platform is built on the principle of
                    reducing complexities for retailers/Sellers integrating into
                    the platform. The seller portal API gives retailers a
                    consistent way of providing and accepting data in a
                    structure and mechanism that is compatible with the majority
                    of retailers/Sellers.
                  </li>
                  <li>
                    The downloadable document that is attached below covers
                    integration into the Seller Portal API which includes feeds
                    for products, product availibility, stock, orders, order
                    notification, order status, documentation and master data.
                  </li>
                </ul>

                <form method="get" action={pdf1} target="_blank">
                  <button type="submit" className="download-btn">
                    Download for more info
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IntegrationProcess;
